import React from 'react';
import { EddyEditTranscriptModalContents } from 'components/EddyEditTranscriptModal';
import Modal from 'components/Modal';

export interface EditCaptionTextModalProps {
  show: boolean;
  eddyProjectId: string;
  onExited: () => void;
}

const EditCaptionTextModal: React.FC<EditCaptionTextModalProps> = ({
  show,
  eddyProjectId,
  onExited,
}) => {
  return (
    <Modal show={show} isFullScreen>
      <EddyEditTranscriptModalContents
        eddyProjectId={eddyProjectId}
        onSave={onExited}
        onCancel={onExited}
      />
    </Modal>
  );
};

export default EditCaptionTextModal;
